// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3q9SD","content":"styles_content__388vO","checkbox":"styles_checkbox__1TjYC","checkboxLabel":"styles_checkboxLabel__2s3uo"};